import { IEvent } from "@Interfaces";
import { isEmpty } from "@Utils";
import { getEventCurrency } from "@Modules/eventPage/utils/getEventCurrency";
import { IOfferPromotion } from "./IOfferPromotion";

export const getOfferPromotionProps = ({
    eventData = {} as IEvent.IEventData,
    discountData,
    isMobile,
    callApplyDiscountApi,
    disablePayment,
}: {
    eventData: IEvent.IEventData;
    discountData: IEvent.IDiscount;
    isMobile: boolean;
    callApplyDiscountApi: IOfferPromotion.IProps["callApplyDiscountApi"];
    disablePayment: boolean;
}): IOfferPromotion.IProps => {
    const coupons = eventData.promotional_coupons || [];
    return {
        coupons,
        hideComponent: disablePayment || isEmpty(coupons),
        isMobile,
        callApplyDiscountApi,
        discountCode: discountData?.discountCode || null,
        currency: getEventCurrency({ eventData }).eventCurrency,
    };
};
